// src/pages/Solutions.js
import Header from '../components/Header';
import Footer from '../components/Footer';

import FeatureSection from '../components/FeatureSection';
const Solutions = () => {
  return (
    <div>
      <Header />
      <FeatureSection/>
      <Footer/>
    </div>
  );
};

export default Solutions;
